import React from "react";
import AddUserModal from "./AddUserModal.js";
import { Button } from "react-bootstrap";

const Footer = (props) => (
  <>
    
     <Button style={{backgroundColor:'rgb(0,0,0,0,0)',border:'none'}}> <AddUserModal onSave={props.addUser} /></Button>

     
   
  </>
);

export default Footer;